import { COLLAPSE, TOGGLE, COLLAPSE_ALL } from './types';
export const collapse = payload => ({
  type: COLLAPSE,
  payload
});
export const toggle = (rowId, viewIndex, allowMultiple) => ({
  type: TOGGLE,
  payload: {
    rowId,
    viewIndex,
    allowMultiple
  }
});
export const collapseAll = () => ({
  type: COLLAPSE_ALL
});